const monthExpired = (year, month, now) => {
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth();

  if (month === '---') {
    return { expirationMonth: '*Required' };
  } else if (
    parseInt(year, 10) === parseInt(currentYear, 10) &&
    parseInt(month, 10) <= parseInt(currentMonth, 10)
  ) {
    return { expirationMonth: '*Card expiration date has expired' };
  }
  return {};
};

const yearExpired = (year, now) => {
  const currentYear = now.getFullYear();
  if (year === '---') {
    return { expirationYear: '*Required' };
  } else if (parseInt(year, 10) < parseInt(currentYear, 10)) {
    return { expirationYear: '*Card expiration date has expired' };
  }
  return {};
};

const ccExpirationValidation = (month, year) => {
  const now = new Date();
  return {
    ...monthExpired(year, month, now),
    ...yearExpired(year, now),
  };
};

export default ccExpirationValidation;



// WEBPACK FOOTER //
// ./src/components/Forms/Validations/ccExpirationValidation.js